<template>
  <div>
    {{title}}
  </div>
</template>

<script>
export default {
  name: "PersonalDaySign",
  data() {
    return {
      title: '我的签到'
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/personal/PersonalDaySign.vue